import React from 'react'
import Navbar from 'components/berberkah/navbar'
import Jumbotron from 'components/berberkah/jumbotron'
import Main from 'components/berberkah/main'
import Cards from 'components/berberkah/cards'
import Testimoni from 'components/berberkah/testimoni'

export default function berberkah() {
    return (
        <>
            <Navbar />
            <Jumbotron />
            <Main />
            <Cards />
            <Testimoni />
        </>
    )
}
